import React, { useState, useEffect, memo } from "react";
import { useParams, Link } from "react-router-dom";
import { masterSchemas } from "../../../core/json/asstmasterscemas";
import Table from "../../../core/pagination/datatable";
import DynamicOffcanvas from "./DynamicOffcanvas";
// import {   useSelector } from "react-redux";
import PropTypes from "prop-types";

const MastersTable = () => {
  const { masterType } = useParams();
  // const masterState = useSelector(
  //   (state) => state.rootReducer.Asset_Mgt_Masters[masterType] || {}
  // );

  const [schema, setSchema] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [title, setTitle] = useState("");
  const [selectedUnit, setSelectedUnit] = useState("");
  // const [selectedMasterType, setSelectedMasterType] = useState("");

  // const UNITS_MAPPING = {
  //   "ro-water-pressure": "ro-water-pressure-units",
  //   "air-pressure-limit": "air-pressure-units",
  //   "dryer-temperature-range": "dryer-temperature-units",
  // };
  const unitsSource = masterSchemas[masterType]?.unitsSource;
  const unitsData = unitsSource ? masterSchemas[unitsSource]?.data || [] : [];

  useEffect(() => {
    if (!masterType) return;
    const config = masterSchemas[masterType];

    if (config) {
      setSchema(config.schema || []);
      setTitle(config.title || "");

      const dataWithKeys = (config.data || []).map((item, index) => ({
        ...item,
        key: item.id ?? index + 1,
      }));

      setDataSource(dataWithKeys);
    } else {
      setSchema([]);
      setTitle("");
      setDataSource([]);
    }
  }, [masterType]);
  const roleId = parseInt(sessionStorage.getItem("selectedRole"));
  // Memoized inner table component
  const MemoizedTable = memo(
    ({ masterType, dataSource, schema, handleEdit }) => {
      return (
        <Table
          key={masterType}
          dataSource={dataSource}
          columns={[
            ...schema.map((field) => ({
              title: field.label.trim(), // Trim leading spaces like in " Status"
              dataIndex: field.name,
              key: field.name,
              render: (text, record) => {
                if (field.type === "checkbox") {
                  return record[field.name] ? (
                    <span className="d-inline-flex align-items-center p-1 pe-2 rounded-1 text-white bg-success fs-10">
                      {" "}
                      <i className="ti ti-point-filled me-1 fs-11"></i>
                      Active
                    </span>
                  ) : (
                    <span className="d-inline-flex align-items-center p-1 pe-2 rounded-1 text-white bg-danger fs-10">
                      {" "}
                      <i className="ti ti-point-filled me-1 fs-11"></i>
                      Inactive
                    </span>
                  );
                }
                return record[field.name]; // Default text rendering
              },
            })),

            ...(roleId === 2 || roleId === 3
              ? [
                  {
                    title: (
                      <div className="d-flex justify-content-center">
                        Actions
                      </div>
                    ),
                    render: (_, record) => (
                      <div className=" action-table-data">
                        <div className="edit-delete-action">
                          <Link
                            title="edit"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#MastersDynamicOffcanvas"
                            aria-controls="MastersDynamicOffcanvas"
                            className="me-2"
                            onClick={() => handleEdit(record, masterType)}
                          >
                            <i
                              data-feather="edit"
                              className="feather-edit text-info"
                            ></i>
                          </Link>
                          <Link title="soft-delete">
                            <i
                              data-feather="trash-2"
                              className="feather-trash-2 text-danger"
                            ></i>
                          </Link>
                        </div>
                      </div>
                    ),
                  },
                ]
              : []),
          ]}
          pagination={false}
          size="small"
        />
      );
    }
  );

  // ✅ Add display name for ESLint
  MemoizedTable.displayName = "MemoizedTable";

  // ✅ PropTypes
  MemoizedTable.propTypes = {
    masterType: PropTypes.string.isRequired,
    dataSource: PropTypes.array.isRequired,
    schema: PropTypes.array.isRequired,
    handleEdit: PropTypes.func.isRequired,
  };

  useEffect(() => {
    console.log("masterType changed to:", masterType); // 👈 Check timing
  }, [masterType]);

  // const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [mode, setMode] = useState("add");
  const [selectedSection, setSelectedSection] = useState();
  const [selectedTitle, setSelectedTitle] = useState();
  // Call this to open Add form
  const handleAdd = (sectionKey) => {
    setMode("add");
    setSelectedRowData(null);
    setSelectedSection(sectionKey);
    setSelectedTitle(title);
    // setShowOffcanvas(true);
  };

  // Call this to open Edit form
  const handleEdit = (row, sectionKey) => {
    setMode("edit");
    setSelectedRowData(row);
    setSelectedSection(sectionKey);
    setSelectedTitle(title);
    // setShowOffcanvas(true);
  };
  if (!title) return <p className="mt-5">Invalid master type or no data</p>;

  const handleFormSubmit = (section, data) => {
    console.log("Submitted to section:", section, data);
    // Add your API call or state update logic here
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/assetmgt/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      {title}
                    </h4>
                  </ol>
                </nav>
                <h6>Manage {title}</h6>
              </div>
            </div>

            {(roleId === 2 || roleId === 3) && (
              <div className="page-btn">
                <Link
                  // to="#"
                  onClick={() => handleAdd(masterType)}
                  // onClick={() => {
                  //   setFormData({});
                  //   setVisible(true);
                  // }}
                  data-bs-toggle="offcanvas"
                  data-bs-target="#MastersDynamicOffcanvas"
                  aria-controls="MastersDynamicOffcanvas"
                  className="btn btn-success btn-sm"
                >
                  <i className="ti ti-circle-plus fs-4"></i>
                </Link>
              </div>
            )}
          </div>

          <div>
            {/* <h4 className="d-flex justify-content-between align-items-center">
              {config.title}
              <button
                size="small"
                onClick={() => {
                  setFormData({});
                  setVisible(true);
                }}
              >
                Add
              </button>
            </h4> */}

            <div className="card table-list-card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3  ">
                <div className="search-set mt-4"></div>
                <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  {unitsData?.length > 0 && (
                    <select
                      className="form-select form-select-sm"
                      value={selectedUnit}
                      onChange={(e) => setSelectedUnit(e.target.value)}
                    >
                      {unitsData?.map((unit) => (
                        <option key={unit.id} value={unit.Unit}>
                          {unit.Unit}
                        </option>
                      ))}
                    </select>
                  )}
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <MemoizedTable
                    masterType={masterType}
                    dataSource={dataSource}
                    schema={schema}
                    handleEdit={handleEdit}
                  />
                </div>
              </div>
            </div>
          </div>
          <DynamicOffcanvas
            // visible={showOffcanvas}
            // onClose={() => setShowOffcanvas(false)}
            title={selectedTitle}
            schema={masterSchemas[selectedSection]?.schema || []}
            section={selectedSection}
            formData={selectedRowData || {}}
            onSubmit={handleFormSubmit}
            mode={mode}
          />
        </div>
      </div>
    </>
  );
};

export default MastersTable;
